import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ce465c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alarm-settings" }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between","align-items":"baseline"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold"} }, "阈值设置", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-bootom red" }, "* 当直播观看人数超过设定值时，在表格中标记为红色并生成告警", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-bootom red" }, "* 当新增关注人数超过设定值时，在表格中标记为红色并生成告警", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-bootom red" }, "* 当分享直播间人数超过设定值时，在表格中标记为红色并生成告警", -1))
const _hoisted_7 = { style: {"display":"flex","justify-content":"space-between","align-items":"baseline"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold"} }, "告警记录", -1))
const _hoisted_9 = {
  key: 0,
  class: "red"
}
const _hoisted_10 = {
  key: 1,
  class: "green"
}

import dayjs from "dayjs";
import {computed, onMounted, ref, watch} from "vue";
import { ElForm, ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import {
  getAlarmList,
  saveThresholds,
  deleteAllAlarm,
  deleteAlarm,
  markAlarm,
  getThresholds
} from "@/service/main/thirdPartyLive";

export default /*#__PURE__*/_defineComponent({
  __name: 'AlarmSettings',
  setup(__props) {

const form = ref({
    watch_uv: '',
    new_follow_uv: '',
    share_uv: ''
})
const page = ref({
  pageNum: 1,
  pageSize: 10,
  total: 0
})
const tableData = ref([
  {
    date: '2016-05-03',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
  },
  {
    date: '2016-05-08',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
  },
  {
    date: '2016-05-06',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
  },
  {
    date: '2016-05-07',
    name: 'Tom',
    address: 'No. 189, Grove St, Los Angeles',
  },
])
onMounted(()=>{
    getTableData();
    getDetail();
})
const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  getTableData();
}
const handleCurrentChange = (pageNum: number) => {
  page.value.pageNum = pageNum
  getTableData();
}
const getTableData = ()=>{ 
      getAlarmList({pageNum: page.value.pageNum, pageSize: page.value.pageSize}).then(res=>{
        tableData.value = res.records
        page.value.total = res.total
    })
}
const add = () => { 
    saveThresholds(
      form.value
    ).then((res) => {
      ElMessage.success('设置成功')
      getDetail();
    })
}
const getDetail = () => { 
    getThresholds().then(res=>{
      form.value = res
    })
}
const clearAll = () => { 
    ElMessageBox.confirm('确定要清空所有告警记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAllAlarm().then(res=>{
          ElMessage.success('清空成功')
          getTableData();
        })
      }).catch(() => {
  })
}
const deleteAlarmItem = (id: string) => { 
    ElMessageBox.confirm('确定要删除该告警记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAlarm(id).then(res=>{
          ElMessage.success('删除成功')
          getTableData();
        })
      })
}
const markAlarmClick = (id: string) => { 
    markAlarm(id).then(res=>{
      ElMessage.success('标记成功')
      getTableData();
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { style: {} }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: add,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存设置")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), { model: form.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              rules: [
                    { type: 'number', message: '请输入数字' },
                ],
              label: "观看人数"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.watch_uv,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.watch_uv) = $event)),
                  modelModifiers: { number: true },
                  style: {"max-width":"300px"},
                  type: "text"
                }, {
                  append: _withCtx(() => [
                    _createTextVNode("人")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_el_form_item, { label: "新增关注人数" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.new_follow_uv,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.new_follow_uv) = $event)),
                  modelModifiers: { number: true },
                  style: {"max-width":"300px"},
                  type: "text"
                }, {
                  append: _withCtx(() => [
                    _createTextVNode("人")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_5,
            _createVNode(_component_el_form_item, { label: "分享直播间人数" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.share_uv,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.share_uv) = $event)),
                  modelModifiers: { number: true },
                  style: {"max-width":"300px"},
                  type: "text"
                }, {
                  append: _withCtx(() => [
                    _createTextVNode("人")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { style: {"margin-top":"10px"} }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: clearAll
            }, {
              default: _withCtx(() => [
                _createTextVNode("清空记录")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              icon: "el-icon-refresh",
              size: "small",
              circle: "",
              style: {"margin-left":"10px"},
              onClick: getTableData
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: tableData.value,
          height: 350,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "时间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "accountName",
              label: "直播间",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "thirdParty",
              label: "三方"
            }, {
              default: _withCtx((scope) => [
                (scope.row.thirdParty)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.thirdParty), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "metricTypeName",
              label: "告警类型"
            }),
            _createVNode(_component_el_table_column, {
              prop: "currentValue",
              label: "当前值"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, {
                  type: "danger",
                  style: {"font-weight":"bold"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.currentValue ? scope.row.currentValue : 0), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "thresholdValue",
              label: "阈值"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "● 未处理"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "● 已处理"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "操作",
              width: "200"
            }, {
              default: _withCtx((scope) => [
                (scope.row.status === 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      plain: "",
                      size: "small",
                      onClick: ($event: any) => (markAlarmClick(scope.row.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("标记已处理")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  type: "danger",
                  plain: "",
                  size: "small",
                  onClick: ($event: any) => (deleteAlarmItem(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          "current-page": page.value.pageNum,
          "page-sizes": [10, 20, 30, 40, 100],
          "page-size": page.value.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: page.value.total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})